module.exports = __webpack_public_path__ + "static/media/ad-post-banner-on-list-mockup-below.394d806b.png";